import {
  GQLPrefecture,
  GQLTestPlacesQuery
} from '../generated/graphql';

export const enum TestArea {
  Hokkaido,
  Tohoku,
  Kanto,
  Kanagawa,
  Chubu,
  Kansai,
  ChugokuAndShikoku,
  Kyushu,
  Okinawa
}

export const testAreaLabelMap = new Map<TestArea, string>([
  [TestArea.Hokkaido, '北海道'],
  [TestArea.Tohoku, '東北地方'],
  [TestArea.Kanto, '関東地方（神奈川県を除く）'],
  [TestArea.Kanagawa, '神奈川県'],
  [TestArea.Chubu, '中部地方'],
  [TestArea.Kansai, '近畿地方'],
  [TestArea.ChugokuAndShikoku, '中国・四国地方'],
  [TestArea.Kyushu, '九州地方（沖縄県を除く）'],
  [TestArea.Okinawa, '沖縄県']
])

export const testAreaLabel = Array.from(testAreaLabelMap.entries()).reduce((obj, [key, value]) => ({...obj, [key]: value}), {} as {[x: number]: string})

export const TestAreaPrefectureMap = new Map < TestArea, GQLPrefecture[] > ([
  [TestArea.Hokkaido, [
    GQLPrefecture.Hokkaido,
  ]],
  [TestArea.Tohoku, [
    GQLPrefecture.Aomori,
    GQLPrefecture.Iwate,
    GQLPrefecture.Miyagi,
    GQLPrefecture.Akita,
    GQLPrefecture.Yamagata,
    GQLPrefecture.Fukushima,
  ]],
  [TestArea.Kanto, [
    GQLPrefecture.Ibaraki,
    GQLPrefecture.Tochigi,
    GQLPrefecture.Gumma,
    GQLPrefecture.Saitama,
    GQLPrefecture.Chiba,
    GQLPrefecture.Tokyo,
  ]],
  [TestArea.Kanagawa, [
    GQLPrefecture.Kanagawa,
  ]],
  [TestArea.Chubu, [
    GQLPrefecture.Niigata,
    GQLPrefecture.Toyama,
    GQLPrefecture.Ishikawa,
    GQLPrefecture.Fukui,
    GQLPrefecture.Yamanashi,
    GQLPrefecture.Nagano,
    GQLPrefecture.Gifu,
    GQLPrefecture.Shizuoka,
    GQLPrefecture.Aichi,
  ]],
  [TestArea.Kansai, [
    GQLPrefecture.Mie,
    GQLPrefecture.Shiga,
    GQLPrefecture.Kyoto,
    GQLPrefecture.Osaka,
    GQLPrefecture.Hyogo,
    GQLPrefecture.Nara,
    GQLPrefecture.Wakayama,
  ]],
  [TestArea.ChugokuAndShikoku, [
    GQLPrefecture.Tottori,
    GQLPrefecture.Shimane,
    GQLPrefecture.Okayama,
    GQLPrefecture.Hiroshima,
    GQLPrefecture.Yamaguchi,
    GQLPrefecture.Tokushima,
    GQLPrefecture.Kagawa,
    GQLPrefecture.Ehime,
    GQLPrefecture.Kochi,
  ]],
  [TestArea.Kyushu, [
    GQLPrefecture.Fukuoka,
    GQLPrefecture.Saga,
    GQLPrefecture.Nagasaki,
    GQLPrefecture.Kumamoto,
    GQLPrefecture.Oita,
    GQLPrefecture.Miyazaki,
    GQLPrefecture.Kagoshima,
  ]],
  [TestArea.Okinawa, [
    GQLPrefecture.Okinawa
  ]]
])

type TestPlace = GQLTestPlacesQuery['testPlaces'][number]
export function groupByArea(testPlaces: TestPlace[]): [TestArea, TestPlace[]][] {
  return Array.from(TestAreaPrefectureMap.entries()).map(([area, prefectures]) => [area as any, testPlaces.filter(testPlace => prefectures.includes(testPlace.prefecture))])
}
